import style from "./style.module.scss";

export default function ListItem(props) {
  const { children, color } = props;
  return (
    <div className={style.list_item} data-color={color}>
      {children}
    </div>
  );
}
